import { Component, OnInit,  Inject} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormBuilder } from '@angular/forms';

import { ScheduleService } from '../schedule/schedule.service';
import { MessagerComponent } from '../messager/messager/messager.component';
import { LoggingService } from './logging.service';
import { EmployeeService } from '../employee/employee.service';
import { AuthService } from '../auth.service';

@Component({
    selector: 'app-email-dialog',
    templateUrl: './grid-email-dialog.html'
})

export class GridEmailComponent implements OnInit {

    constructor(public dialogRef: MatDialogRef<GridEmailComponent>, @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder, private scheduleService: ScheduleService, private authService: AuthService, private employeeService: EmployeeService, public messager: MessagerComponent, public log: LoggingService ) {}

    header = ' Send Email '
    body = ' Are you sure you want to send an email? '
    usernamee = this.data.usernamee
    job= this.data.job
    loc= this.data.loc
    triggered_by = '';
    email = '';

  ngOnInit() {

    this.employeeService.getOneEmployee(this.job.technitian).subscribe(
      res =>{
        this.email = res.e_mail || '';
      }
    )

    this.authService.userProfile$.subscribe(
      (profile) => {
        let user = profile;
        this.usernamee = user ? user.nickname.charAt(0).toUpperCase() + user.nickname.slice(1) : '';
        this.triggered_by = this.usernamee; 

      });


  }

  onNoClick(): void {
    this.dialogRef.close();
  }


sendResultsEmail(): void {

    this.dialogRef.close(1)
    this.messager.openSnackBar('Preparing email...', '', 'successAlert', 15000);
    this.job.photos = {};
    this.job.jb = {};
    this.job.rf = {};
    this.job.notes = {};

    this.job.subdivision_name = this.loc.subdivision_name || '(No Subdivision)';
    this.job.lot = this.loc.lot || '(No Lot)';
    this.job.street_address = this.loc.street_address;
    this.job.state = this.loc.state;
    this.job.form_id = this.loc.form_id;
    this.job.e_mail = this.email;
    this.job.triggered_by = this.triggered_by;

    this.scheduleService.getRaterPicslocmain(this.loc.locpics_id).subscribe(
      res => {
        if (res.Error) {
          this.log.error(this.usernamee + ' experienced an error sending schedule email for job id-' + this.job.job_id + ': ' + res.Message);
          this.messager.openSnackBar('There was an error sending email: ' + res.Message, '', 'errorAlert');
          return;
        }
        this.job.photos = res.Photos;
        this.scheduleService.getRaterNotes(this.job.location_id).subscribe(
          res => {
            if (res.Error) {
              this.messager.openSnackBar('There was an error sending email: ' + res.Message, '', 'errorAlert');
              return;
            }
            this.job.notes = res.Notes;
            var successString = 'Email Sent to ' + this.job.contact_e_mail + "," + this.loc.contacts;

            this.scheduleService.getDataByFormID(this.loc.form_id).subscribe(
              res => {
                this.job.rf = res.formData;
                if (res.Error) {

                } else {

          if(this.job.employee_id == 110 || this.job.employee_id == 165 || this.job.employee_id == 95 || this.job.employee_id == 188 || this.job.employee_id == 168){
            this.job.contact_e_mail = this.job.contact_e_mail.trim() + ",gregd@theperformancepoint.com";
          }
          //Christian gets Ryan and Nick's emails
          if(this.job.employee_id == 136 || this.job.employee_id == 164 || this.job.employee_id == 76 || this.job.employee_id == 179 ){
            this.job.contact_e_mail = this.job.contact_e_mail.trim() + ",cristianl@theperformancepoint.com,Alexe@theperformancepoint.com";
          }
          //Alex gets David B and Chad's emails
          if(this.job.employee_id == 39 || this.job.employee_id == 143 || this.job.employee_id == 197 || this.job.employee_id == 194){
            this.job.contact_e_mail = this.job.contact_e_mail.trim() + ",Alexe@theperformancepoint.com";
          }
          //Matt F gets Mark, Andy and Richard
          if(this.job.employee_id == 170 || this.job.employee_id == 176 || this.job.employee_id == 154){
            this.job.contact_e_mail = this.job.contact_e_mail.trim() + ",Mattf@theperformancepoint.com";
          }
          if(this.job.employee_id == 182 || this.job.employee_id == 183){
            this.job.contact_e_mail = this.job.contact_e_mail.trim() + ",HunterC@theperformancepoint.com";
          }

          if( this.job.customer_name.trim().includes('True') && (this.loc.subdivision == 524 || this.loc.subdivision == 224 || this.loc.subdivision == 2531 || this.loc.subdivision == 1636  || this.job.subdivision == 2652 || this.loc.subdivision == 2799 || this.loc.subdivision == 2141 || this.loc.subdivision == 1714 || this.loc.subdivision == 2688 || this.loc.subdivision == 1649 || this.loc.subdivision == 1789 || this.loc.subdivision == 2072 || this.loc.subdivision == 2910 || this.loc.subdivision == 2754 || this.loc.subdivision == 477 || this.loc.subdivision == 2782 || this.loc.subdivision == 2990)  ){
            this.job.contact_e_mail = this.job.contact_e_mail.trim() + ',ccole@truehomesusa.com,CButtrill@truehomesusa.com';
           }

           if(this.job.customer_name.trim().includes('True') && (this.loc.city.trim().includes('Winston-Salem') || this.loc.city.trim().includes('Greensboro') || this.loc.city.trim().includes('High Point')  ) ){
            this.job.contact_e_mail = this.job.contact_e_mail.trim() + ',rsands@truehomesusa.com,bmcwhirter@truehomesusa.com';
           }

          var isCustom = this.job.customer_jobtype.toLowerCase().includes('cust') && !this.job.customer_jobtype.toLowerCase().includes('customer');
          var isProd = this.job.customer_jobtype.toLowerCase().includes('prod');
          //Matt Hudgins TRUE Homes distribution request. 
          // Raleigh, Triad, Charlotte North, Charlotte South, Charlotte West
          if(this.job.customer_name.toLowerCase().includes('true')){
            let region; 
            this.scheduleService.getTrueHomesRegions(this.job.subdivision).subscribe(
              res => {
                if(!res.Error || res.Region.bldr_region.length > 1){
            
                  region = res.Region.bldr_region.toLowerCase();
                  if(region.includes('triad')){
                    this.job.contact_e_mail = this.job.contact_e_mail.trim() + ",bmcguffin@truehomesusa.com,bmcwhirter@truehomesusa.com,rsands@truehomesusa.com";
                  }else if(region.includes('north')){
                    this.job.contact_e_mail = this.job.contact_e_mail.trim() + ",rsimmons@truehomesusa.com,rmulhern@truehomesusa.com,cbuttrill@truehomesusa.com,ccole@truehomesusa.com";
                  }else if(region.includes('south')){
                    this.job.contact_e_mail = this.job.contact_e_mail.trim() + ",rsimmons@truehomesusa.com,rmulhern@truehomesusa.com,wgross@truehomesusa.com,scoberth@truehomesusa.com";
                  }else if(region.includes('west')){
                    this.job.contact_e_mail = this.job.contact_e_mail.trim() + ",rsimmons@truehomesusa.com,rmulhern@truehomesusa.com,bcrysler@truehomesusa.com,bshuman@truehomesusa.com";
                  }

                }
              }
            )

          }


          if(this.job.customer_name.toLowerCase().includes('dr horton col')){
            if(this.job.customer_jobtype.toLowerCase().includes('db&bd')){
              this.job.contact_e_mail = this.job.contact_e_mail.trim() + ",AHFloyd@drhorton.com,SNBishop@drhorton.com,"
            }
          }

          if(this.job.customer_name.toLowerCase().includes('mattamy')){
              this.job.contact_e_mail = this.job.contact_e_mail.trim() + "Justin.Russell@mattamycorp.com,Jason.Cooper@mattamycorp.com,Matthew.Byington@mattamycorp.com,";
          }

          if(this.job.customer_name.toLowerCase().trim().includes('true charlotte')){
            if(this.job.customer_jobtype.toLowerCase().includes('pdwi')){
              this.job.contact_e_mail = this.job.contact_e_mail.trim() + ",Jessica.C@insulation-holdings.com,"
            }
          }

            this.scheduleService.sendEmail(this.job).subscribe(
              res => {
                if (res.Error) {
                  this.messager.openSnackBar('There was an error sending email: ' + res.Message, '', 'errorAlert');
                  this.log.error(this.usernamee + ' experienced an error sending schedule email for job id-' + this.job.job_id + ': ' + res.Message);
                  this.dialogRef.close(1)
                } else {
                  this.messager.openSnackBar(successString, '', 'successAlert');
                  this.dialogRef.close(1)
                }
              },
              err => {
                this.messager.openSnackBar('There was an app error sending email: ' + err, '', 'errorAlert');
                this.dialogRef.close(1)
              }
                  );
                }
              }, err => {
              }
            )
          }, err => {
            this.messager.openSnackBar('There was an app error sending email: ' + err, '', 'errorAlert');
            this.dialogRef.close(1)
          })

      }, err => {
        this.messager.openSnackBar('There was an app error sending email: ' + err, '', 'errorAlert');
        this.dialogRef.close(1)
      });
  }


}


